import styled, { css } from 'styled-components';

import { media } from 'DesignLibrary/global';
import { cardStyling, selectedRedStyling } from 'DesignLibrary/utils';

export const Content = styled.div`
  > * + * {
    margin-top: var(--sizing-sm);
  }
`;

export const ButtonGrid = styled.div`
  display: flex;
  gap: var(--sizing-xs);

  button {
    flex-grow: 2;
  }
`;

interface WaiveContainerProps {
  isCoverageWaived: boolean;
}

export const WaiveContainer = styled.div<WaiveContainerProps>`
  ${cardStyling}
  padding: var(--sizing-sm);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sizing-sm);

  ${({ isCoverageWaived }) =>
    isCoverageWaived &&
    css`
      ${selectedRedStyling}
    `}

  ${media.TABLET`
    flex-direction: row;
    justify-content: space-between;
    padding: var(--sizing-sm) var(--sizing-md);
  `}
`;

export const WaiveButton = styled.div`
  width: 100%;
  background: var(--colors-red-50);

  ${media.TABLET`
    max-width: var(--sizing-4xl);
  `}
`;
export const ClaimsCard = styled.div`
  hr {
    margin-bottom: 1rem;

    + .paragraph {
      font-size: 0.875rem;
    }
  }

  .claims-numbers {
    font-size: 0.875rem;
    color: var(--colors-alex-ink80);
    font-weight: 300;
    margin-bottom: 1rem;

    .numbers {
      &:first-child {
        font-size: 1.25rem;
        font-weight: 700 !important;
        color: var(--colors-gray-black);

        span {
          font-size: 0.875rem;
        }
      }

      &:nth-child(2) {
        font-size: 0.875rem;
        color: var(--colors-alex-ink80);
        display: inline-block;
        margin-right: 0.25rem;
        font-weight: 300;
      }
    }
  }
`;
export const ClaimsTitle = styled.div`
  margin-bottom: 1.5rem;

  h5 {
    font-size: 1.25rem;
    font-weight: 700 !important;
    line-height: 1.2;
  }

  div > span[role='img']:first-of-type {
    background: var(--colors-blue-50);
    padding: 0.75rem;
    margin-right: 1rem;
    border-radius: 0.5rem;
  }
`;

export const ClaimsLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;

  > div {
    border: 0 !important;
  }
`;
export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin: 0px var(--sizing-md) 0px var(--sizing-sm);

  p {
    color: var(--text-gray);
  }
`;

export const FeedbackText = styled.span`
  font-family: 'Museo Sans', sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0;
  color: #338bad;
`;

interface IconButtonProps {
  active?: boolean;
}

export const IconButton = styled.button<IconButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  background: ${(props) => (props.active ? '#6AAFCA' : 'transparent')};
  svg {
    width: 17px;
    height: 16px;
    fill: #036991;
    &:hover {
      fill: #024e6e;
    }
  }
`;

export const FeedbackContainer = styled.div`
  position: relative;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #f5fcff;
  border-radius: 4px;
  margin: 0 -24px;
  margin-bottom: 16px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 24px;
  background: none;
  border: none;
  cursor: pointer;
`;

export const FeedBackInputWrapper = styled.div`
  margin-left: 1rem;

  button {
    height: 38px;
    float: right;
    width: 89px !important;
    background: var(--primary-blue) !important;
    color: white;
    border: none;
  }
`;

export const FeedbackInput = styled.textarea`
  width: 100%;
  height: 60px;
  border-radius: 8px;
  border: 1px solid #828297;
  padding: 8px 10px;
  resize: none;
  outline: none;

  font-family: 'Museo Sans', sans-serif;
  font-size: 12px;
  font-weight: 300;
  line-height: 20px;
  color: #828297;

  &::placeholder {
    color: #828297;
    font-family: 'Museo Sans', sans-serif;
    font-size: 12px;
    font-weight: 300;
    line-height: 20px;
  }

  &:focus {
    border-color: #036991;
    box-shadow: 0 0 0 2px rgba(3, 105, 145, 0.2);
  }
`;

export const FeedbackWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 1rem;
  margin-top: 0;
`;
